import { Component, Input, OnInit } from '@angular/core';
import { IconListBaseComponent } from '@moduurnv2/libs-orderingapp';
import { ThemeOptions } from '@moduurnv2/features/ui/directives';

@Component({
  selector: 'moduurnv2-icon-list',
  templateUrl: 'icon-list.component.html',
  styleUrls: ['icon-list.component.scss'],
})
export class IconListComponent extends IconListBaseComponent implements OnInit {
  @Input('icons') itemIcons: any[];
  @Input('showText') showText: boolean = false;
  options: ThemeOptions = {
    // appFontFamily: true
}
  constructor() {
    super();
  }

  ngOnInit() {
    // this.itemIcons = this.itemIcons
    //   .map((iconId) => {
    //     let foundIcon: any = Icons.find((icon) => icon.id === iconId);
    //     if (foundIcon) return foundIcon;
    //   })
    //   .filter((icon) => icon !== undefined);
  }

}
